import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './ObservationsTab.module.scss';
import Observation from './Observation/Observation';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'client/components/aria/Button/Button';
import { mapModes } from 'client/utils/constants/appStates';
import { permissions } from 'client/utils/constants/permissions';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';
import { useHasUserPermission } from 'client/utils/auth/userPermissions';
import { addMapMode, removeMapMode } from 'client/store/mapSlice/mapSlice';

const ObservationsTab = ({ assetsInAOIOwners, ...props }) => {
    const dispatch = useDispatch();
    const isAddingObservation = useSelector(state => (state.map.mode || []).includes(mapModes.ADDING_OBSERVATION));
    const observations = useSelector(state => state.assets.layers.observation || []);

    const permissionToCreate = useHasUserPermission(permissions.OBSERVATIONS_CREATE);

    const handleCreateButtonPressed = () => {
        if (isAddingObservation) {
            dispatch(removeMapMode(mapModes.ADDING_OBSERVATION));
        } else {
            dispatch(addMapMode(mapModes.ADDING_OBSERVATION));
        }
    };

    const observationsSortedByDate = [...observations].sort((a, b) => {
        const observationDateA = a.getProperties().datelastupdated;
        const observationDateB = b.getProperties().datelastupdated;
        if (observationDateA === observationDateB) {
            return 0;
        }
        return observationDateB > observationDateA ? 1 : -1;
    });

    return <div
        className={styles.container}
        data-testid={props['data-testid']}
    >
        <div className={styles.content} data-testid={`${props['data-testid']}.content`}>
            {observationsSortedByDate.length
                ? observationsSortedByDate.map(feature => <Observation feature={feature} key={feature.getProperties().dataproviderassigneduniqueid} />)
                : <div className={styles.noMessage}><FormattedMessage id={'observationsTab.noObservations'}/></div>
            }
        </div>

        {permissionToCreate && <Button
            className={styles.createButton}
            onPress={handleCreateButtonPressed}
            variant={isAddingObservation ? 'error' : 'default'}
            data-testid={`${props['data-testid']}.createButton`}
        >
            <FormattedMessage id={isAddingObservation ? 'general.cancel' : 'observationsTab.createObservation'}/>
        </Button>}
    </div>;
};

ObservationsTab.propTypes = {
    'data-testid': PropTypes.string,
    ...defaultAriaProps
};

ObservationsTab.defaultProps = {
    'data-testid': 'observationsTab'
};

export default ObservationsTab;
